'use client';

import { usePathname, useSearchParams } from 'next/navigation';
import NProgress from 'nprogress';
import { useCallback, useEffect, useState } from 'react';

const useRouteNavigation = () => {
	const [isChanging, setIsChanging] = useState(false);
	const pathname = usePathname();
	const searchParams = useSearchParams();

	const onRouteStartNavigating = useCallback(() => {
		NProgress.start();
	}, []);

	const onRouteCompleteNavigating = useCallback(() => {
		NProgress.done();
	}, []);

	const startProgress = useCallback(() => {
		setIsChanging(true);
	}, []);

	useEffect(() => {
		setIsChanging(false);
	}, [pathname, searchParams, isChanging]);

	useEffect(() => {
		if (isChanging) onRouteStartNavigating();
		else onRouteCompleteNavigating();
	}, [isChanging, pathname, searchParams, onRouteCompleteNavigating, onRouteStartNavigating]);

	return {
		startProgress,
	};
};

export default useRouteNavigation;
